import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { AdminPlaybooksPage } from "@/components/admin/playbooks/AdminPlaybooksPage";

export const Route = createFileRoute("/admin/playbooks")({
  component: AdminPlaybooksRoute,
});

function AdminPlaybooksRoute() {
  return (
    <AdminGuard>
      <AdminPlaybooksPage />
    </AdminGuard>
  );
}
